var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"lg":"9","cols":"12","order":"1","order-lg":"1"}},[_c('b-card',[_c('router-view')],1)],1),_c('b-col',{attrs:{"lg":"3","cols":"12","order":"2"}},[_c('instructions-card')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }